// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const RainfallEvents = {
  StandardRainfallEvent1: "Standard rainfall event 1",
  StandardRainfallEvent2: "Standard rainfall event 2",
  StandardRainfallEvent3: "Standard rainfall event 3",
  StandardRainfallEvent4: "Standard rainfall event 4",
  StandardRainfallEvent5: "Standard rainfall event 5",
  StandardRainfallEvent6: "Standard rainfall event 6",
  StandardRainfallEvent7: "Standard rainfall event 7",
  StandardRainfallEvent8: "Standard rainfall event 8",
  StandardRainfallEvent9: "Standard rainfall event 9",
  StandardRainfallEvent10: "Standard rainfall event 10",
} as const;
export type RainfallEvents = (typeof RainfallEvents)[keyof typeof RainfallEvents];

export function instanceOfRainfallEvents(value: any): boolean {
  for (const key in RainfallEvents) {
    if (Object.prototype.hasOwnProperty.call(RainfallEvents, key)) {
      if (RainfallEvents[key as keyof typeof RainfallEvents] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RainfallEventsFromJSON(json: any): RainfallEvents {
  return RainfallEventsFromJSONTyped(json, false);
}

export function RainfallEventsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RainfallEvents {
  return json as RainfallEvents;
}

export function RainfallEventsToJSON(value?: RainfallEvents | null): any {
  return value as any;
}

export function RainfallEventsToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): RainfallEvents {
  return value as RainfallEvents;
}
